var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('main',[_c('userLogin')],1),_c('footer',[_vm._v(" Copyright © "+_vm._s(_vm.date)+" "),_c('span',{staticStyle:{"color":"#1890ff"}},[_vm._v("哈哈医疗")]),_vm._v(" 出品 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }